import http from "../http/http-config";

export default new class SelectedProducerService {
    //Movilidad Urbana 
    GetSelectedProducer(clientCode, localId, officeCode, originId, zipCode): Promise<boolean> {
        return http.get<boolean>("GetSelectedProducer", {
            params: {
                clientCode,
                localId,
                officeCode,
                originId,
                zipCode
            }
        }).then(response => response.data);
    }

}